module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09BF44RJZ.01135e5f.jpg";